import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadEditorDependencies } from 'ProtectedRoute/useLoadEditorDependencies';

const PreviewLessonDirective = angularDirectiveToReact('previewLesson', {});

export function PreviewLessonComponent() {
    useLoadEditorDependencies();
    const [key] = useAngularToReactRoute();
    return <PreviewLessonDirective key={key} />;
}
